import { CARDIO_CHECK_ACCOUNTS } from "static/account";
import {
  CLINIC_NAMES,
  CLINIC_ROLES,
  FACILITY_MAP,
  REPORT_ASSIGNMENT_CLINICS,
} from "static/constants";

export const filterNonUCHAccounts = (accounts) => {
  return accounts?.filter((account) => {
    const accountNameMapper = {
      object: account?.name,
      string: account,
    };

    return accountNameMapper[typeof account] !== CLINIC_NAMES.UCH;
  });
};

/**
 * Check if the clinic has access to report assignment feature
 * @param {Object} clinic
 * @returns {Boolean}
 */
export const checkReportAssignmentAccess = (user) => {
  return REPORT_ASSIGNMENT_CLINICS.some((clinic) =>
    user?.accounts?.includes(clinic)
  );
};

/**
 * Checks if the user has any accounts listed in the CARDIO_CHECK_ACCOUNTS.
 *
 * @param {Object} user - The user object to check.
 * @param {Array<string>} [user.accounts] - The list of accounts associated with the user.
 * @returns {boolean} - Returns `true` if the user has at least one account in CARDIO_CHECK_ACCOUNTS, otherwise `false`.
 */
export const checkCardioCheckAccounts = (user) => {
  return CARDIO_CHECK_ACCOUNTS.some((account) =>
    user?.accounts?.includes(account)
  );
};

export const checkSaasAccount = (accounts, selectedAccount) => {
  return accounts?.find((account) => account?.name === selectedAccount)
    ?.saas_account;
};

export const checkRPMSaaSAccount = (accounts, selectedAccount) => {
  return accounts?.find((account) => account?.name === selectedAccount)
    ?.rpm_only;
};

export const getFacilityByAccountName = (accountName) => {
  return Object.keys(FACILITY_MAP).find((facility) =>
    FACILITY_MAP[facility]?.allAccounts?.includes(accountName)
  );
};

export const belongsToTenantFacility = (accountMap, account) => {
  return accountMap[account]?.facility?.includes("TENET");
};

export const checkQuickTextTemplateAccess = (accounts, user) => {
  const isClinicUser = CLINIC_ROLES.includes(user?.role);

  const hasAccess = accounts.some(
    (account) => account.settings?.show_quick_text_templates
  );

  return isClinicUser && hasAccess;
};
